import { TableCell, TableRow } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  MAIN_COLOR,
  MAIN_LIGHT_COLOR,
  SECOND_LIGHT_GRAY,
} from '../../themes/colors';
import { TABLE_CELL } from '../../themes/fonts';
import InfoIcon from '@mui/icons-material/Info';
import { IArea, ISafety } from '../../redux/safety/types';
import { getDate } from '../../libs/utils/formatDate';

interface Props {
  data: ISafety[];
  onClickDetail: (safetyId: number) => void;
}

const useStyles = makeStyles({
  tableCellText: {
    color: `${SECOND_LIGHT_GRAY} !important`,
    fontSize: `${TABLE_CELL} !important`,
  },

  icon: {
    color: MAIN_COLOR,
    '&:hover': {
      color: MAIN_LIGHT_COLOR,
      cursor: 'pointer',
    },
  },
});

const TableBody = ({ data, onClickDetail }: Props) => {
  const styles = useStyles();

  const handleRenderTargetArea = (targetArea: IArea[]) => {
    const areaNames = targetArea.map((area: IArea) => area.area_name);
    return areaNames.join(', ');
  };

  return (
    <>
      {data?.map((row, rowIndex) => (
        <TableRow key={rowIndex}>
          <TableCell
            align="center"
            key="title"
            className={styles.tableCellText}
          >
            {row['title']}
          </TableCell>
          <TableCell
            align="center"
            key="target_area"
            className={styles.tableCellText}
          >
            {handleRenderTargetArea(row['target_area'])}
          </TableCell>
          <TableCell
            align="center"
            key="detail"
            className={styles.tableCellText}
          >
            {row['detail']}
          </TableCell>
          <TableCell
            align="center"
            key="post_date"
            className={styles.tableCellText}
          >
            {getDate(row['created_at'].toString(), 'YYYY/MM/DD HH:mm')}
          </TableCell>
          <TableCell
            align="center"
            key="edit_action"
            className={styles.tableCellText}
          >
            <InfoIcon
              className={styles.icon}
              onClick={() => onClickDetail(row['safety_notifications_id'])}
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default TableBody;
